// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"15ce4a8e","453":"84d425c2"}[chunkId] + ".chunk.js";
};